import { render, staticRenderFns } from "./dish-ingredient-table.vue?vue&type=template&id=6740ec7a&scoped=true&"
import script from "./dish-ingredient-table.vue?vue&type=script&lang=js&"
export * from "./dish-ingredient-table.vue?vue&type=script&lang=js&"
import style0 from "./dish-ingredient-table.vue?vue&type=style&index=0&id=6740ec7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6740ec7a",
  null
  
)

export default component.exports